import Image from 'app/Components/Shared/Image/image';
import React, { useState, useLayoutEffect, useEffect, useRef ,useMemo} from 'react';
import SwiperCore from 'swiper';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { prepareUrl } from 'app/utilities/StringHelpers/StringHelpers';
import { getMarketCode } from 'app/utilities/domain/domainConstants';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

SwiperCore.use([Navigation, Pagination]);
export default function CircularSwiperDesktop(props) {
  //console.log(props);
  const [swiper, setSwiper] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    if (swiper != null && swiper.slides && props.isFetchLoginData) props.handleSelectedIndex(swiper, props.arr);
  }, [props.currentPage, window.location.pathname]);

  const marketCode = getMarketCode().toLowerCase();
  const getBalanacedIconsInSwiper = (index, total, maxY = 25) => {
    if (total <= 1) return 0;
    const center = (total - 1) / 2;
    const distance = Math.abs(index - center);
    return Math.round((distance / center) * maxY);
  };

  const getSlidersStyle = (swiper) => {
    if (!swiper) return;
    const swiperSlides = swiper.slides;
    if (!swiperSlides || swiperSlides.length === 0) return;

    swiperSlides.forEach((slide, i) => {
      if (slide) {
        slide.style.transform = `translateY(${getBalanacedIconsInSwiper(i, swiperSlides.length)}px)`;
      }
    });
  };
  useEffect(() => {
    if (swiper) {
      getSlidersStyle(swiper);
    }
  }, [swiper, props.isFetchLoginData]);
 
  const getImageUrl =( itemId, extension,isGrayImg )=>{
      
    const folder =`./images/icons/${itemId.toLowerCase()}/${itemId.toLowerCase()}`;
    if(itemId !=null){
        if (extension === 'gif' || itemId === 'main') {
          return require(`${folder}-${marketCode}.${extension}`);
        }
        return require(`${folder}${isGrayImg ? "-gray" : ""}.${extension}`);
      }
      return null;
  }

  return (

    <div className={`main-container ${props.selectedIndex == 0 ? 'first-slide' : ''}`}>
      {props.isFetchLoginData && props.arr != null && <>
        <Swiper
          onSwiper={(swiperInstance) => {
            setSwiper(swiperInstance);
          }}

          onInit={((swiper) => getSlidersStyle(swiper), (swiper) => props.handleSelectedIndex(swiper, props.arr))}
          initialSlide={props.activeIndex}
          onReachEnd={() => { }}
          slidesPerView={6}
          slidesPerGroup={1}
          spaceBetween={2}
          centeredSlides={false}
          navigation={false}
          pagination={false}
          allowTouchMove={false}
          style={{ overflow: 'hidden' }}
          loop={false}
          slidesOffsetBefore={0}
          slidesOffsetAfter={0}>
          {props.arr.map((item, i) => (
            <SwiperSlide key={i}
              className={`${props.selectedIndex === i ? 'selected' : ''} ${isHovered == i ? 'hovered' : ''}`}
            >
              <div
                onMouseEnter={() => setIsHovered(i)}
                onMouseLeave={() => setIsHovered(-1)}
                onClick={(event) => {
                  // event.preventDefault();

                  prepareUrl(item.worldLink, props.context);
                  // props.setSelectedIndex(swiper.clickedIndex);
                }} className={`circle ${props.selectedIndex == i ? 'selected' : ''} ${!item.tabData && i != 0 ? "grey" : ""}`}>


        {(i === 0 || item.tabData) ? (
          props.selectedIndex === i
            ? <Image src={getImageUrl(item.id, 'gif',false)} />
          : <Image src={getImageUrl(item.id, 'svg',false)} />
        ) : (
          <Image src={getImageUrl(item.id, 'png',true)} />
        )}



{item.isShowBadge && (
  <div className='circle-badge'>
    <Image src={props.epiBaseUrl + item.badgeImg} />
  </div>
)}

  {!item.tabData && i != 0 && <div className='circle-badge'>{<span><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="14" cy="14" r="12" fill="#FFDE31" />
                  <circle cx="14" cy="14" r="12.5714" stroke="#BAB68B" strokeOpacity="0.2" strokeWidth="1.14286" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M13.9939 19.8202C14.3545 19.8202 14.6457 19.5289 14.6457 19.1683L14.6503 14.6518L19.1715 14.6518C19.5321 14.6518 19.8233 14.3606 19.8233 14C19.8233 13.6394 19.5321 13.3482 19.1715 13.3482L14.6503 13.3482L14.6503 8.82703C14.6503 8.46645 14.3591 8.17521 13.9985 8.17521C13.6379 8.17521 13.3467 8.46645 13.3467 8.82703L13.3467 13.3482H8.82556C8.46497 13.3482 8.17373 13.6394 8.17374 14C8.17373 14.3606 8.46497 14.6518 8.82556 14.6518H13.3467L13.3467 19.173C13.3467 19.5243 13.6426 19.8202 13.9939 19.8202Z" fill="black" />
                </svg>
                </span>}</div>}
              </div>
              <div className='circle-text-container'>
                <div className='circle-text title'>{item.tabTitle}</div>
                <div className='circle-text sub-title'>{item.tabSubTitle}</div>
              </div>

            </SwiperSlide>
       ))}
        </Swiper>
      </>}
    </div>
  );
}

